import React from 'react'
import {FormattedNumber} from 'react-intl'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface AppLockedDealTotalPriceProps {
  value: number
  currency: string
  hasUnderline?: boolean
  textVariant?: 'bodyXS' | 'labelXS'
}

const StyledText = styled(Text)`
  display: flex;
  &.--underline {
    text-decoration: underline;
  }
`

export const GHAPreferredRateTotalPrice = ({
  value,
  currency,
  hasUnderline = false,
  textVariant = 'bodyXS'
}: AppLockedDealTotalPriceProps) => (
  <StyledText
    variant={textVariant}
    colorPath="content.neutral.secondary"
    as="div"
    className={cx(hasUnderline && '--underline')}
  >
    <FormattedNumber
      maximumFractionDigits={0}
      value={value}
      style="currency"
      currency={currency}
    />
    <span>&nbsp;</span>
    <FormattedMessageWrapper id="payment.total" defaultMessage="total" />
  </StyledText>
)
